// import React, { useState, useEffect, useMemo } from "react";
// import { Box, Typography, ButtonGroup, Button, Popover } from "@mui/material";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import {
//   ResponsiveContainer,
//   ComposedChart,
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   Cell,
// } from "recharts";

// // ─── Format a date string into a friendly "Mon, Jan 15, 2026" label ──────────
// const formatTooltipDate = (dateStr) => {
//   if (!dateStr) return "";
//   const date = new Date(dateStr);
//   if (isNaN(date.getTime())) return "";
//   return date.toLocaleDateString("en-US", {
//     weekday: "short",
//     month: "short",
//     day: "numeric",
//     year: "numeric",
//   });
// };

// // ─── Custom Tooltip ───────────────────────────────────────────────────────────
// const CustomTooltip = ({ active, payload }) => {
//   if (active && payload && payload.length) {
//     const row = payload[0].payload;
//     const headerLabel = row.fullDate ? formatTooltipDate(row.fullDate) : row.name;
//     return (
//       <Box
//         sx={{
//           backgroundColor: "#ffffff",
//           border: "1px solid #e2e8f0",
//           padding: "10px 14px",
//           borderRadius: "10px",
//           boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
//         }}
//       >
//         <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#1a2d4d", mb: 0.5 }}>
//           {headerLabel}
//         </Typography>
//         {payload.map((p, i) => { 
//           const displayValue = p.dataKey === "attendanceRate" 
//             ? `${p.value}%` 
//             : p.value;
//           return (
//             <Box key={i} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//               <Box sx={{ width: 8, height: 8, backgroundColor: p.color || "#3b82f6", borderRadius: "50%" }} />
//               <Typography sx={{ fontSize: 11, color: "#64748b" }}>
//                 {p.name}:{" "}
//                 <span style={{ color: "#1a2d4d", fontWeight: 700 }}>
//                   {displayValue}
//                 </span>
//               </Typography>
//             </Box>
//           );
//         })}
//       </Box>
//     );
//   }
//   return null;
// };

// const fmtK = (v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v);
// const fmtPercent = (v) => `${v}%`;

// // ─── VIEW MODES ───────────────────────────────────────────────────────────────
// const VIEWS = [
//   { key: "week",  label: "Week"  },
//   { key: "month", label: "Month" },
//   { key: "year",  label: "Year"  },
//   { key: "range", label: "Range" },
// ];

// // ─── Legend Component ────────────────────────────────────────────────────────
// const LegendDot = ({ color, label, isLine = false }) => (
//   <Box sx={{ display: "flex", gap: 0.8, alignItems: "center" }}>
//     {isLine ? (
//       <Box sx={{ width: 20, height: 3, backgroundColor: color, borderRadius: "2px" }} />
//     ) : (
//       <Box sx={{ width: 9, height: 9, borderRadius: "50%", backgroundColor: color }} />
//     )}
//     <Typography sx={{ fontSize: { xs: 9, sm: 10 }, color: "#64748b" }}>{label}</Typography>
//   </Box>
// );

// const ChartLegend = () => (
//   <Box
//     sx={{
//       display: "flex",
//       gap: { xs: 1.5, sm: 3 },
//       alignItems: "center",
//       pt: 2,
//       borderTop: "1px solid #e5e7eb",
//       flexWrap: "wrap",
//     }}
//   >
//     <LegendDot color="#3b82f6" label="Attendance" />
//     <LegendDot color="#f59e0b" label="Attendance Rate" isLine />
//   </Box>
// );

// // ─── Empty State ─────────────────────────────────────────────────────────────
// const EmptyState = ({ height = 200, message = "No data available" }) => (
//   <Box
//     sx={{
//       height,
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       color: "#94a3b8",
//       fontSize: 13,
//       gap: 1,
//     }}
//   >
//     <Box sx={{ fontSize: 40, opacity: 0.3 }}>📊</Box>
//     <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>{message}</Typography>
//   </Box>
// );

// // ─── FIXED BAR SIZE ──────────────────────────────────────────────────────────
// const getFixedBarSize = (dataLength) => {
//   if (dataLength <= 7) return 32;
//   if (dataLength <= 15) return 28;
//   if (dataLength <= 31) return 24;
//   if (dataLength <= 60) return 20;
//   if (dataLength <= 90) return 16;
//   if (dataLength <= 180) return 12;
//   return 10;
// };

// // ─── Date Range Picker Component ────────────────────────────────────────────────
// const DateRangePicker = ({
//   startDate,
//   endDate,
//   onStartChange,
//   onEndChange,
//   isMobile,
//   show = true
// }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   if (!show) {
//     return null;
//   }

//   return (
//     <>
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={handleClick}
//         startIcon={<CalendarTodayIcon />}
//         sx={{
//           fontSize: { xs: "10px", sm: "11px" },
//           textTransform: "none",
//           color: "#004AAD",
//           borderColor: "#004AAD",
//           px: { xs: 1.5, sm: 2 },
//           py: 0.65,
//           "&:hover": {
//             backgroundColor: "rgba(0,74,173,0.07)",
//             borderColor: "#003a8c",
//           },
//         }}
//       >
//         {startDate && endDate
//           ? `${formatTooltipDate(startDate)} - ${formatTooltipDate(endDate)}`
//           : "Select Range"}
//       </Button>

//       <Popover
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'right',
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//         PaperProps={{
//           sx: {
//             p: 2,
//             maxWidth: { xs: "90vw", sm: 400 },
//             width: { xs: "90vw", sm: 380 },
//           }
//         }}
//       >
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//             <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1a2d4d" }}>
//               Select Date Range
//             </Typography>

//             <DatePicker
//               label="Start Date"
//               value={startDate}
//               onChange={onStartChange}
//               maxDate={endDate || new Date()}
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   fullWidth: true,
//                 }
//               }}
//             />

//             <DatePicker
//               label="End Date"
//               value={endDate}
//               onChange={onEndChange}
//               minDate={startDate}
//               maxDate={new Date()}
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   fullWidth: true,
//                 }
//               }}
//             />

//             <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 1 }}>
//               <Button
//                 size="small"
//                 variant="outlined"
//                 onClick={() => {
//                   onStartChange(null);
//                   onEndChange(null);
//                   handleClose();
//                 }}
//                 sx={{ textTransform: "none" }}
//               >
//                 Clear
//               </Button>
//               <Button
//                 size="small"
//                 variant="contained"
//                 onClick={handleClose}
//                 sx={{
//                   textTransform: "none",
//                   backgroundColor: "#004AAD",
//                   "&:hover": { backgroundColor: "#003a8c" }
//                 }}
//               >
//                 Apply
//               </Button>
//             </Box>
//           </Box>
//         </LocalizationProvider>
//       </Popover>
//     </>
//   );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// export function WeeklyAttendanceTrend({
//   weeklyApiData = [],
// }) {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
//   const [view, setView] = useState("week");
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 600);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // ─── Filter and process data based on date ranges ──────────────────────────
//   const processData = useMemo(() => {
//     console.log("WeeklyAttendanceTrend - Received data:", weeklyApiData);

//     if (!weeklyApiData || weeklyApiData.length === 0) {
//       return { weekData: [], monthData: [], yearData: [], rangeData: [] };
//     }

//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     const filterByDateRange = (data, startDate, endDate) => {
//       return data
//         .filter(item => {
//           if (!item.AttDate) return false;
//           const itemDate = new Date(item.AttDate);
//           itemDate.setHours(0, 0, 0, 0);
//           return itemDate >= startDate && itemDate <= endDate;
//         })
//         .sort((a, b) => new Date(a.AttDate) - new Date(b.AttDate));
//     };

//     //  attendance rate
// const calculateAttendanceRate = (item) => {
//   const attendance = parseInt(item.Attendance) || 0;

//   const actualStrength = parseInt(localStorage.getItem("ActualStrength")) || 0;

//   if (actualStrength === 0) return 0;

//   return Math.round((attendance / actualStrength) * 100);
// };

//     // ── WEEK DATA (last 7 days including today) ──
//     const weekStart = new Date(today);
//     weekStart.setDate(today.getDate() - 6);
//     const weekRawData = filterByDateRange(weeklyApiData, weekStart, today);

//     const weekData = weekRawData.map(item => ({
//       name: item.DayName ? item.DayName.substring(0, 3) : "N/A",
//       attendance: parseInt(item.Attendance) || 0,
//       attendanceRate: calculateAttendanceRate(item),
//       fullDate: item.AttDate,
//       dayName: item.DayName || "",
//     }));

//     // ── MONTH DATA (1st of current month to today) ──
//     const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
//     const monthRawData = filterByDateRange(weeklyApiData, monthStart, today);

//     const monthData = monthRawData.map(item => {
//       const date = new Date(item.AttDate);
//       return {
//         name: String(date.getDate()),
//         attendance: parseInt(item.Attendance) || 0,
//         attendanceRate: calculateAttendanceRate(item),
//         fullDate: item.AttDate,
//         dayName: item.DayName || "",
//       };
//     });

//     // ── YEAR DATA (Jan 1 of current year to today - ALL DAYS) ──
//     const yearStart = new Date(today.getFullYear(), 0, 1);
//     const yearRawData = filterByDateRange(weeklyApiData, yearStart, today);

//     const yearData = yearRawData.map(item => {
//       const date = new Date(item.AttDate);
//       const label = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

//       return {
//         name: label,
//         fullDate: item.AttDate,
//         dayName: item.DayName || "",
//         attendance: parseInt(item.Attendance) || 0,
//         //attendanceRate: calculateAttendanceRate(item),
//       };
//     });

//     // ── RANGE DATA (custom date range) ──
//     let rangeData = [];
//     if (startDate && endDate) {
//       const rangeRawData = filterByDateRange(weeklyApiData, startDate, endDate);
//       rangeData = rangeRawData.map(item => {
//         const date = new Date(item.AttDate);
//         const label = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//         return {
//           name: label,
//           fullDate: item.AttDate,
//           dayName: item.DayName || "",
//           attendance: parseInt(item.Attendance) || 0,
//           attendanceRate: calculateAttendanceRate(item),
//         };
//       });
//     }

//     const result = { weekData, monthData, yearData, rangeData };
//     console.log("WeeklyAttendanceTrend - Processed data:", result);
//     return result;
//   }, [weeklyApiData, startDate, endDate]);

//   const { weekData, monthData, yearData, rangeData } = processData;

//   // ── Derived ───────────────────────────────────────────────────────────────
//   const isRangeView = view === "range";

//   const chartHeight = isMobile ? 280 : 340;
//   const yAxisWidth = isMobile ? 48 : 58;

//   const chartMargin = {
//     top: 16,
//     right: isMobile ? -8 : -12,
//     left: isMobile ? -18 : -20,
//     bottom: 10,
//   };

//   const titles = {
//     week: { title: "DGES Weekly Attendance", sub: "Last 7 days attendance" },
//     month: { title: "DGES Monthly Attendance", sub: `${new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' })} - Daily attendance breakdown` },
//     year: { title: "DGES Yearly Attendance", sub: `Attendance from Jan 1 to ${new Date().toLocaleString('en-US', { month: 'long', day: 'numeric' })}` },
//     range: {
//       title: "DGES Custom Range Attendance",
//       sub: startDate && endDate
//         ? `${formatTooltipDate(startDate)} to ${formatTooltipDate(endDate)}`
//         : "Select a date range to view data"
//     },
//   };

//   // ─── Get current data based on view ──────────────────────────────────────
//   const getCurrentData = () => {
//     switch (view) {
//       case 'week': return weekData;
//       case 'month': return monthData;
//       case 'year': return yearData;
//       case 'range': return rangeData;
//       default: return yearData;
//     }
//   };

//   const currentData = getCurrentData();
//   const isEmpty = currentData.length === 0;

//   // ─── Handle view change ─────────────────────────────────────────────────
//   const handleViewChange = (newView) => {
//     setView(newView);
//     if (newView !== "range") {
//       setStartDate(null);
//       setEndDate(null);
//     }
//   };

//   console.log("WeeklyAttendanceTrend - Current view:", view, "Data length:", currentData.length);

//   // ─── Render Chart ──────────────────────────────────────────────────────────
//   const renderChart = () => {
//     if (isEmpty) {
//       return (
//         <EmptyState
//           height={chartHeight}
//           message={view === "range" && !startDate && !endDate
//             ? "Please select a date range using the calendar button"
//             : `No data available for ${view} view`}
//         />
//       );
//     }

//     const barSize = getFixedBarSize(currentData.length);

//     const getTickInterval = () => {
//       if (currentData.length <= 15) return 0;
//       if (currentData.length <= 31) return 2;
//       if (view === "year") return 10;
//       if (currentData.length <= 60) return 4;
//       if (currentData.length <= 100) return 6;
//       if (currentData.length <= 180) return 10;
//       return Math.floor(currentData.length / 20);
//     };

//     const shouldAngleLabels = currentData.length > 20;
//     const labelAngle = shouldAngleLabels ? -45 : 0;
//     const labelAnchor = shouldAngleLabels ? "end" : "middle";
//     const labelHeight = 30;

//     const getTickFontSize = () => {
//       if (currentData.length <= 15) return 11;
//       if (currentData.length <= 31) return 10;
//       if (currentData.length <= 60) return 9;
//       if (currentData.length <= 100) return 8;
//       return 8;
//     };

//     return (
//       <Box sx={{ height: chartHeight, width: "100%" }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <ComposedChart
//             data={currentData}
//             margin={chartMargin}
//             barCategoryGap="30%"
//             barGap={0}
//           >
//             <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
//             <XAxis
//               dataKey="name"
//               axisLine={false}
//               tickLine={false}
//               tick={{
//                 fill: "#64748b",
//                 fontSize: getTickFontSize()
//               }}
//               angle={labelAngle}
//               textAnchor={labelAnchor}
//               height={labelHeight}
//               interval={getTickInterval()}
//             />
            
//             {/* Left Y-Axis for Attendance */}
//             <YAxis
//               yAxisId="left"
//               orientation="left"
//               tickLine={false}
//               axisLine={false}
//               tick={{ fill: "#64748b", fontSize: 10 }}
//               width={yAxisWidth}
//               tickFormatter={fmtK}
//               domain={[0, 'auto']}
//             />
            
//             {/* Right Y-Axis for Attendance Rate */}
//             <YAxis
//               yAxisId="right"
//               orientation="right"
//               tickLine={false}
//               axisLine={false}
//               tick={{ fill: "#64748b", fontSize: 10 }}
//               width={yAxisWidth}
              
//               tickFormatter={fmtPercent}
//               domain={[0, 100]}
//             />
            
//             <Tooltip content={<CustomTooltip />} />

//             {/* Attendance Bar */}
//             <Bar
//               yAxisId="left"
//               dataKey="attendance"
//               name="Attendance"
//               barSize={barSize}
//               fill="#3b82f6"
//               radius={[6, 6, 6, 6]}
//             >
//               {currentData.map((entry, index) => (
//                 <Cell
//                   key={`cell-${index}`}
//                   fill={entry.attendance > 100 ? "#2563eb" : "#3b82f6"}
//                 />
//               ))}
//             </Bar>

//             {/* Attendance Rate Line */}
//             <Line
//               yAxisId="right"
//               type="monotone"
//               dataKey="attendanceRate"
//               name="Attendance Rate"
//               stroke="#f59e0b"
//               strokeWidth={2}
//              dot={false}  
//               activeDot={false}  
//             />
//           </ComposedChart>
//         </ResponsiveContainer>
//       </Box>
//     );
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box sx={{ 
//         "@keyframes fadeInUp": {
//           "0%": { opacity: 0, transform: "translateY(10px)" },
//           "100%": { opacity: 1, transform: "translateY(0)" }
//         },
//         animation: "fadeInUp 0.5s ease-out forwards"
//       }}>
//         <Box
//           sx={{
//             overflow: "hidden",
//             backgroundColor: "#ffffff",
//             borderRadius: "12px",
//             padding: { xs: "14px", sm: "20px" },
//             boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
//             border: "1px solid #e2e8f0",
//           }}
//         >
//           {/* ── Header ── */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//               flexWrap: "wrap",
//               gap: 1,
//               mb: 2,
//             }}
//           >
//             <Box>
//               <Typography sx={{ fontSize: { xs: 13, sm: 15 }, fontWeight: 700, color: "#1a2d4d", mb: "2px" }}>
//                 {titles[view].title}
//               </Typography>
//               <Typography sx={{ fontSize: { xs: 10, sm: 11 }, color: "#94a3b8" }}>
//                 {titles[view].sub}
//               </Typography>
//             </Box>

//             {/* ── Controls ── */}
//             <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
//               <ButtonGroup size="small" variant="outlined" sx={{ borderRadius: "5px", overflow: "hidden" }}>
//                 {VIEWS.map(({ key, label }) => (
//                   <Button
//                     key={key}
//                     onClick={() => handleViewChange(key)}
//                     disableRipple={false}
//                     sx={{
//                       fontSize: { xs: "10px", sm: "11px" },
//                       px: { xs: 1.4, sm: 2 },
//                       py: 0.65,
//                       textTransform: "none",
//                       fontWeight: view === key ? 700 : 500,
//                       backgroundColor: view === key ? "#004AAD" : "transparent",
//                       color: view === key ? "#ffffff" : "#004AAD",
//                       borderColor: "#004AAD",
//                       transition: "all 0.2s",
//                       "&:hover": {
//                         backgroundColor: view === key ? "#003a8c" : "rgba(0,74,173,0.07)",
//                         borderColor: "#003a8c",
//                       },
//                     }}
//                   >
//                     {label}
//                   </Button>
//                 ))}
//               </ButtonGroup>

//               <DateRangePicker
//                 startDate={startDate}
//                 endDate={endDate}
//                 onStartChange={(date) => {
//                   setStartDate(date);
//                   if (date && endDate && date > endDate) {
//                     setEndDate(null);
//                   }
//                 }}
//                 onEndChange={(date) => {
//                   setEndDate(date);
//                   if (date && startDate && date < startDate) {
//                     setStartDate(null);
//                   }
//                 }}
//                 isMobile={isMobile}
//                 show={isRangeView}
//               />
//             </Box>
//           </Box>

//           {/* ════════════════════════════════════════
//               CHART - RENDER
//           ════════════════════════════════════════ */}
//           {renderChart()}
//           {!isEmpty && <ChartLegend />}
//         </Box>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default WeeklyAttendanceTrend;







import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography, ButtonGroup, Button, Popover } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ReferenceLine,
  Line,
} from "recharts";

const toNum = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  if (typeof val === "number") return isNaN(val) ? 0 : val;
  const cleaned = String(val).replace(/,/g, "").trim();
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
};

const getWeekNumber = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 3 - (d.getDay() + 6) % 7);
  const week1 = new Date(d.getFullYear(), 0, 4);
  return 1 + Math.round(((d - week1) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

const getWeekStart = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  d.setDate(d.getDate() + diff);
  return d;
};

const getMonthName = (date) => {
  return date.toLocaleDateString('en-US', { month: 'short' });
};

const getYear = (date) => {
  return date.getFullYear();
};

const getYearFromWeek = (weekNum, year) => {
  const date = new Date(year, 0, 1 + (weekNum - 1) * 7);
  return date.getFullYear();
};

// ─── Format functions ──────────────────────────────────────────────────────────
const formatTooltipDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const fmtK = (v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v);

// ─── Custom Tooltip ───────────────────────────────────────────────────────────
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const row = payload[0].payload;
    const isAggregated = !!row.periodDays && row.periodDays > 1;
 
    const headerLabel = isAggregated
      ? row.monthLabel
        ? `Week ${row.name} · ${row.monthLabel} (avg of ${row.periodDays} day${row.periodDays === 1 ? "" : "s"})`
        : `${row.name} (avg of ${row.periodDays} day${row.periodDays === 1 ? "" : "s"})`
      : (formatTooltipDate(row.fullDate) || row.name);

    return (
      <Box
        sx={{
          backgroundColor: "#ffffff",
          border: "1px solid #e2e8f0",
          padding: "10px 14px",
          borderRadius: "10px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
        }}
      >
        <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#1a2d4d", mb: 0.5 }}>
          {headerLabel}
        </Typography>
        {payload.map((p, i) => {
          if (p.dataKey === "rate" && p.payload.hasData !== false) {
            return (
              <Box key={i} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Box sx={{ width: 8, height: 8, backgroundColor: "#f59e0b", borderRadius: "50%" }} />
                <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                  Rate:{" "}
                  <span style={{ color: "#1a2d4d", fontWeight: 700 }}>
                    {p.value}%
                  </span>
                </Typography>
              </Box>
            );
          }
          if (p.dataKey === "attendance") {
            return (
              <Box key={i} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Box sx={{ width: 8, height: 8, backgroundColor: p.color || "#3b82f6", borderRadius: "50%" }} />
                <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                  Attendance:{" "}
                  <span style={{ color: "#1a2d4d", fontWeight: 700 }}>
                    {p.value}
                  </span>
                </Typography>
              </Box>
            );
          }
          return null;
        })}
      </Box>
    );
  }
  return null;
};

const WeekAxisTick = ({ x, y, payload, index, weekData, isMobile }) => {
  const item = weekData?.[index];
  if (!item) return null;
  
  if (isMobile && index % 4 !== 0) {
    return null;
  }
  
  const hourNum = payload.value;
  const monthLabel = item.monthLabel || '';
  
  const shouldShowMonth = () => {
    if (!monthLabel) return false;
    if (index === 0) return true;
    
    const prevItem = weekData?.[index - 1];
    if (prevItem && prevItem.monthLabel !== monthLabel) {
      return true;
    }
    
    if (isMobile) {
      const monthNum = new Date(item.fullDate).getMonth();
      return monthNum % 2 === 0 && index % 4 === 0;
    }
    
    return true;
  };
  
  const showMonth = shouldShowMonth();
  const fontSize = isMobile ? 8 : 10;
  const monthFontSize = isMobile ? 7 : 9;
  
  return (
    <g transform={`translate(${x},${y})`}>
      <text 
        x={0} 
        y={0} 
        dy={isMobile ? 8 : 10} 
        textAnchor="middle" 
        fontSize={fontSize} 
        fill="#64748b"
        fontWeight={showMonth ? "600" : "400"}
      >
        {hourNum}
      </text>
      
      {showMonth && monthLabel && (
        <text 
          x={0} 
          y={0} 
          dy={isMobile ? 22 : 26} 
          textAnchor="middle" 
          fontSize={monthFontSize} 
          fill="#1e1e1f"
          fontWeight="700"
        >
          {monthLabel}
        </text>
      )}
    </g>
  );
};

const MonthAxisTick = ({ x, y, payload, index, monthData, isMobile }) => {
  const item = monthData?.[index];
  if (!item) return null;

 

  const monthLabel = item.name || '';
  const hasData = item.hasData !== false;

  const fontSize = isMobile ? 8 : 10;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={isMobile ? 10 : 12}
        textAnchor="middle"
        fontSize={fontSize}
        fill={hasData ? "#1e1e1f" : "#94a3b8"}
        fontWeight={hasData ? "600" : "400"}
        opacity={hasData ? 1 : 0.5}
      >
        {monthLabel}
      </text>
    </g>
  );
};


// ─── YearAxisTick - Shows Year with Average ─────────────────────────────────
const YearAxisTick = ({ x, y, payload, index, yearData, isMobile }) => {
  const item = yearData?.[index];
  if (!item) return null;
  
  const year = payload.value;
  const avg = item.yearAverage || 0;
  
  const fontSize = isMobile ? 10 : 12;
  const avgFontSize = isMobile ? 7 : 9;
  
  return (
    <g transform={`translate(${x},${y})`}>
      <text 
        x={0} 
        y={0} 
        dy={isMobile ? 8 : 10} 
        textAnchor="middle" 
        fontSize={fontSize} 
        fill="#1e1e1f"
        fontWeight="700"
      >
        {year}
      </text>
    </g>
  );
};

// ─── Legend Component ────────────────────────────────────────────────────────
const LegendDot = ({ color, label }) => (
  <Box sx={{ display: "flex", gap: 0.8, alignItems: "center" }}>
    <Box sx={{ width: 9, height: 9, borderRadius: "50%", backgroundColor: color }} />
    <Typography sx={{ fontSize: { xs: 9, sm: 10 }, color: "#64748b" }}>{label}</Typography>
  </Box>
);

const ChartLegend = ({ showTarget = true }) => (
  <Box
    sx={{
      display: "flex",
      gap: { xs: 1, sm: 2 },
      alignItems: "center",
      pt: 2,
      borderTop: "1px solid #e5e7eb",
      flexWrap: "wrap",
    }}
  >
    <LegendDot color="#3b82f6" label="Attendance" />
    <LegendDot color="#f59e0b" label="Rate (%)" />
    {showTarget && (
      <Box sx={{ ml: "auto", display: "flex", gap: 1, alignItems: "center" }}>
        <Box sx={{ width: 20, height: 0, borderBottom: "2px dashed #ef4444" }} />
        <Typography sx={{ fontSize: { xs: 9, sm: 10 }, color: "#64748b" }}>Target Rate</Typography>
      </Box>
    )}
  </Box>
);

// ─── Empty State ─────────────────────────────────────────────────────────────
const EmptyState = ({ height = 200, message = "No data available" }) => (
  <Box
    sx={{
      height,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#94a3b8",
      fontSize: 13,
      gap: 1,
    }}
  >
    <Box sx={{ fontSize: 40, opacity: 0.3 }}>📊</Box>
    <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>{message}</Typography>
  </Box>
);

// ─── FIXED BAR SIZE ──────────────────────────────────────────────────────────
const getFixedBarSize = (dataLength) => {
  if (dataLength <= 7) return 32;
  if (dataLength <= 15) return 28;
  if (dataLength <= 31) return 24;
  if (dataLength <= 60) return 20;
  if (dataLength <= 90) return 16;
  if (dataLength <= 180) return 12;
  return 10;
};

// ─── Date Range Picker Component ────────────────────────────────────────────
const DateRangePicker = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  isMobile,
  show = true
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!show) {
    return null;
  }

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
        startIcon={<CalendarTodayIcon />}
        sx={{
          fontSize: { xs: "10px", sm: "11px" },
          textTransform: "none",
          color: "#004AAD",
          borderColor: "#004AAD",
          px: { xs: 1.5, sm: 2 },
          py: 0.65,
          "&:hover": {
            backgroundColor: "rgba(0,74,173,0.07)",
            borderColor: "#003a8c",
          },
        }}
      >
        {startDate && endDate
          ? `${formatTooltipDate(startDate)} - ${formatTooltipDate(endDate)}`
          : "Select Range"}
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            p: 2,
            maxWidth: { xs: "90vw", sm: 400 },
            width: { xs: "90vw", sm: 380 },
          }
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1a2d4d" }}>
              Select Date Range
            </Typography>

            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={onStartChange}
              maxDate={endDate || new Date()}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                }
              }}
            />

            <DatePicker
              label="End Date"
              value={endDate}
              onChange={onEndChange}
              minDate={startDate}
              maxDate={new Date()}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                }
              }}
            />

            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 1 }}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  onStartChange(null);
                  onEndChange(null);
                  handleClose();
                }}
                sx={{ textTransform: "none" }}
              >
                Clear
              </Button>
              <Button
                size="small"
                variant="contained"
                onClick={handleClose}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#004AAD",
                  "&:hover": { backgroundColor: "#003a8c" }
                }}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </LocalizationProvider>
      </Popover>
    </>
  );
};

// ─── DATA ENRICHMENT FUNCTIONS ─────────────────────────────────────────────

const enrichWeekDataWithMonth = (weeks, year) => {
  const allWeeks = [];
  const targetYear = year || new Date().getFullYear();

  for (let weekNum = 1; weekNum <= 53; weekNum++) {
    const existingData = weeks.find(w => {
      const wDate = new Date(w.fullDate);
      return getWeekNumber(wDate) === weekNum && 
             getYearFromWeek(weekNum, targetYear) === targetYear;
    });
    
    const date = new Date(targetYear, 0, 1 + (weekNum - 1) * 7);
    const monthName = getMonthName(date);
    
    allWeeks.push({
      name: String(weekNum),
      weekNumber: weekNum,
      year: targetYear,
      monthLabel: monthName,
      fullLabel: `Week ${weekNum} (${monthName} ${targetYear})`,
      fullDate: date.toISOString(),
      attendance: existingData ? existingData.attendance : 0,
      actualStrength: existingData ? existingData.actualStrength : 0,
      rate: existingData ? existingData.rate : null, 
      periodDays: existingData ? existingData.periodDays : 0,
      hasData: !!existingData,
      ...(existingData || {})
    });
  }

  return allWeeks;
};

const enrichMonthDataWithAllMonths = (months, year) => {
  const allMonths = [];
  const targetYear = year || new Date().getFullYear();

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
    const existingData = months.find(m => {
      const mDate = new Date(m.fullDate);
      return mDate.getMonth() === monthIndex && mDate.getFullYear() === targetYear;
    });

    const date = new Date(targetYear, monthIndex, 1);

    allMonths.push({
      name: monthNames[monthIndex],
      monthIndex: monthIndex,
      year: targetYear,
      monthLabel: monthNames[monthIndex],
      fullLabel: `${monthNames[monthIndex]} ${targetYear}`,
      fullDate: date.toISOString(),
      attendance: existingData ? existingData.attendance : 0,
      actualStrength: existingData ? existingData.actualStrength : 0,
      rate: existingData ? existingData.rate : null,
      periodDays: existingData ? existingData.periodDays : 0,
      hasData: !!existingData,
      ...(existingData || {})
    });
  }

  return allMonths;
};

// ─── VIEWS ──────────────────────────────────────────────────────────────────
const VIEWS = [
  { key: "week",  label: "Week"  },
  { key: "month", label: "Month" },
  { key: "year",  label: "Year"  },
  
];

// ─── Main Component ───────────────────────────────────────────────────────────
export function WeeklyAttendanceTrend({
  weeklyApiData = [],
  actualStrengthStorageKey = "ActualStrength",
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [view, setView] = useState("week");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
 
  const [actualStrength, setActualStrength] = useState(() =>
    toNum(window.localStorage.getItem(actualStrengthStorageKey))
  );

  useEffect(() => {
    setActualStrength(toNum(window.localStorage.getItem(actualStrengthStorageKey)));

    const handleStorage = (e) => {
      if (e.key === actualStrengthStorageKey) {
        setActualStrength(toNum(e.newValue));
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [actualStrengthStorageKey]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const processData = useMemo(() => {
    if (!weeklyApiData || weeklyApiData.length === 0) {
      return { weekData: [], monthData: [], yearData: [], rangeData: [] };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const filterByDateRange = (data, startDate, endDate) => {
      return data
        .filter(item => {
          if (!item.AttDate) return false;
          const itemDate = new Date(item.AttDate);
          itemDate.setHours(0, 0, 0, 0);
          return itemDate >= startDate && itemDate <= endDate;
        })
        .sort((a, b) => new Date(a.AttDate) - new Date(b.AttDate));
    };

    const aggregateByPeriod = (data, keyFn, labelFn, sortKeyFn, actualStrengthConst) => {
      const groups = {};

      data.forEach(item => {
        const date = new Date(item.AttDate);
        if (isNaN(date.getTime())) return;
        const key = keyFn(date);
        if (!groups[key]) {
          groups[key] = {
            key,
            sortKey: sortKeyFn(date),
            label: labelFn(date),
            repDate: date,
            attendanceSum: 0,
            count: 0,
          };
        }
        groups[key].attendanceSum += toNum(item.Attendance);
        groups[key].count += 1;
      });

      return Object.values(groups)
        .sort((a, b) => a.sortKey - b.sortKey)
        .map(g => {
          const avgAttendance = g.count ? g.attendanceSum / g.count : 0;
          const rate = actualStrengthConst > 0
            ? Math.round((avgAttendance / actualStrengthConst) * 100)
            : 0;

          return {
            name: g.label,
            attendance: Math.round(avgAttendance),
            actualStrength: actualStrengthConst,
            rate: rate,
            fullDate: g.repDate.toISOString(),
            dayName: "",
            periodDays: g.count,
          };
        });
    };

    const rawWeekData = aggregateByPeriod(
      weeklyApiData,
      (date) => {
        const weekStart = getWeekStart(date);
        const weekNum = getWeekNumber(weekStart);
        const year = getYear(weekStart);
        return `${year}-${String(weekNum).padStart(2, '0')}`;
      },
      (date) => {
        const weekStart = getWeekStart(date);
        const weekNum = getWeekNumber(weekStart);
        return String(weekNum);
      },
      (date) => {
        const weekStart = getWeekStart(date);
        const weekNum = getWeekNumber(weekStart);
        const year = getYear(weekStart);
        return new Date(year, 0, 1 + (weekNum - 1) * 7).getTime();
      },
      actualStrength
    );

    let dataYear = new Date().getFullYear();
    if (rawWeekData.length > 0) {
      const firstDate = new Date(rawWeekData[0].fullDate);
      if (!isNaN(firstDate.getTime())) {
        dataYear = getYear(firstDate);
      }
    }

    const weekData = enrichWeekDataWithMonth(rawWeekData, dataYear);

    const rawMonthData = aggregateByPeriod(
      weeklyApiData,
      (date) => `${getYear(date)}-${date.getMonth()}`,
      (date) => getMonthName(date),
      (date) => new Date(getYear(date), date.getMonth(), 1).getTime(),
      actualStrength
    );

    let monthYear = new Date().getFullYear();
    if (rawMonthData.length > 0) {
      const firstDate = new Date(rawMonthData[0].fullDate);
      if (!isNaN(firstDate.getTime())) {
        monthYear = getYear(firstDate);
      }
    }

    const monthData = enrichMonthDataWithAllMonths(rawMonthData, monthYear);

    // ── Process Year Data ──
    const yearRawData = aggregateByPeriod(
      weeklyApiData,
      (date) => `${getYear(date)}`,
      (date) => `${getYear(date)}`,
      (date) => new Date(getYear(date), 0, 1).getTime(),
      actualStrength
    );

    const yearData = yearRawData.map(item => {
      const year = parseInt(item.name);
      const yearItems = weeklyApiData.filter(d => {
        const date = new Date(d.AttDate);
        return getYear(date) === year;
      });

      const totalAttendance = yearItems.reduce((sum, d) => sum + toNum(d.Attendance), 0);
      const yearAverage = yearItems.length > 0 ? Math.round(totalAttendance / yearItems.length) : 0;
      const yearRate = actualStrength > 0
        ? Math.round((yearAverage / actualStrength) * 100)
        : 0;

      return {
        ...item,
        yearAverage,
        yearRate,
        name: String(year),
        hasData: true,
      };
    });

    // ── Process Range Data ──
    let rangeData = [];
    if (startDate && endDate) {
      const rangeRawData = filterByDateRange(weeklyApiData, startDate, endDate);
      rangeData = rangeRawData.map(item => {
        const date = new Date(item.AttDate);
        const label = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        const attendance = toNum(item.Attendance);
        const rate = actualStrength > 0 ? Math.round((attendance / actualStrength) * 100) : 0;

        return {
          name: label,
          fullDate: item.AttDate,
          dayName: item.DayName || "",
          attendance: attendance,
          actualStrength: actualStrength,
          rate: rate,
          hasData: true,
        };
      });
    }

    return { weekData, monthData, yearData, rangeData };
  }, [weeklyApiData, startDate, endDate, actualStrength]);

  const { weekData, monthData, yearData, rangeData } = processData;

  // ── Derived ───────────────────────────────────────────────────────────────
  const isRangeView = view === "range";
  const isMonthView = view === "month";
  const isYearView = view === "year";
  const isWeekView = view === "week";

  const chartHeight = isMobile ? 280 : 340;
  const yAxisWidth = isMobile ? 48 : 58;

  const chartMargin = {
    top: 16,
    right: isMobile ? -8 : -12,
    left: isMobile ? -18 : -20,
    bottom: isWeekView ? (isMobile ? 20 : 10) : 10,
  };

  const titles = {
    week: { 
      title: "DGES Weekly Attendance", 
    },
    month: { 
      title: "DGES Monthly Attendance", 
    },
    year: { 
      title: "DGES Yearly Attendance", 
    },
    range: {
      title: "DGES Custom Range Attendance",
      sub: startDate && endDate
        ? `${formatTooltipDate(startDate)} to ${formatTooltipDate(endDate)}`
        : "Select a date range to view data"
    },
  };

  const getCurrentData = () => {
    switch (view) {
      case 'week': return weekData;
      case 'month': return monthData;
      case 'year': return yearData;
      case 'range': return rangeData;
      default: return yearData;
    }
  };

  const currentData = getCurrentData();
  const isEmpty = currentData.length === 0;

  const handleViewChange = (newView) => {
    setView(newView);
    if (newView !== "range") {
      setStartDate(null);
      setEndDate(null);
    }
  };


  const renderRateLine = () => {
    const dataWithRate = currentData.filter(d => d.hasData !== false && d.rate !== null && d.rate !== undefined);
    
    if (dataWithRate.length === 0) return null;

    return (
      <Line
        key="rate-line"
        yAxisId="right"
        type="monotone"
        dataKey="rate"
        name="Rate"
        stroke="#f59e0b"
        strokeWidth={2.5}
        dot={(props) => {
          const { cx, cy, payload } = props;
          if (!payload || payload.hasData === false || payload.rate === null) {
            return null;
          }
          return (
            <circle
              cx={cx}
              cy={cy}
              r={isMobile ? 3 : 4}
              fill="#f59e0b"
              stroke="none"
            />
          );
        }}
        activeDot={(props) => {
          const { cx, cy, payload } = props;
          if (!payload || payload.hasData === false || payload.rate === null) {
            return null;
          }
          return (
            <circle
              cx={cx}
              cy={cy}
              r={isMobile ? 5 : 6}
              fill="#f59e0b"
              stroke="#ffffff"
              strokeWidth={2}
            />
          );
        }}
        connectNulls={false}
      />
    );
  };


const renderChart = () => {
  if (isEmpty) {
    return (
      <EmptyState
        height={chartHeight}
        message={view === "range" && !startDate && !endDate
          ? "Please select a date range using the calendar button"
          : `No data available for ${view} view`}
      />
    );
  }

  const barSize = getFixedBarSize(currentData.length);
  const isWeekView = view === "week";
  const isMonthView = view === "month";
  const isYearView = view === "year";

  const getTickInterval = () => {
    if (isWeekView) return 0;
    if (isMonthView) {
      if (currentData.length <= 12) return 0;
      return 1;
    }
    if (isYearView) {
      if (currentData.length <= 5) return 0;
      return 0;
    }

    if (currentData.length <= 15) return 0;
    if (currentData.length <= 31) return 2;
    if (currentData.length <= 60) return 4;
    if (currentData.length <= 100) return 6;
    return Math.floor(currentData.length / 20);
  };

  const getTickComponent = () => {
    if (isWeekView) {
      return <WeekAxisTick weekData={currentData} isMobile={isMobile} />;
    }
    if (isMonthView) {
      return <MonthAxisTick monthData={currentData} isMobile={isMobile} />;
    }
    if (isYearView) {
      return <YearAxisTick yearData={currentData} isMobile={isMobile} />;
    }

    return {
      fill: "#64748b",
      fontSize: isMobile ? 8 : 10
    };
  };

  const shouldAngleLabels = !isWeekView && !isYearView && currentData.length > 20;
  const labelAngle = shouldAngleLabels ? -45 : 0;
  const labelAnchor = shouldAngleLabels ? "end" : "middle";
  const labelHeight = isWeekView ? (isMobile ? 30 : 25) : (shouldAngleLabels ? 50 : 30);

  return (
    <Box sx={{ height: chartHeight, width: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          data={currentData}
          margin={chartMargin}
          barCategoryGap={isMobile ? "20%" : "30%"}
          barGap={0}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
          
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={getTickComponent()}
            angle={labelAngle}
            textAnchor={labelAnchor}
            height={labelHeight}
            interval={getTickInterval()}
          />
          
          {/* Left Y-Axis for Attendance */}
          <YAxis
            yAxisId="left"
            orientation="left"
            tickLine={false}
            axisLine={false}
            tick={{ fill: "#64748b", fontSize: isMobile ? 8 : 10 }}
            width={yAxisWidth}
            tickFormatter={fmtK}
          />
          
          {/* Right Y-Axis for Rate (%) */}
          <YAxis
            yAxisId="right"
            orientation="right"
            tickLine={false}
            axisLine={false}
            tick={{ fill: "#64748b", fontSize: isMobile ? 8 : 10 }}
            width={yAxisWidth}
            domain={[0, 100]}
            tickFormatter={(v) => `${v}%`}
          />
          
          <Tooltip content={<CustomTooltip />} />

          {/* Bar: Attendance - Only show bars for data points with actual data */}
          <Bar
            yAxisId="left"
            dataKey="attendance"
            name="Attendance"
            barSize={barSize}
            fill="#3b82f6"
            radius={[4, 4, 0, 0]}
            shape={(props) => {
              const { payload, x, y, width, height } = props;
              // Don't render bar if no data
              if (!payload || payload.hasData === false) {
                return null;
              }
              return (
                <rect
                  x={x}
                  y={y}
                  width={width}
                  height={height}
                  fill="#3b82f6"
                  rx={4}
                  ry={4}
                />
              );
            }}
          />

          {/* Rate Line - Only shows for data points with actual data */}
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="rate"
            name="Rate"
            stroke="#f59e0b"
            strokeWidth={2.5}
            dot={(props) => {
              const { cx, cy, payload } = props;
              // Only show dots for data points with actual data
              if (!payload || payload.hasData === false || payload.rate === null) {
                return null;
              }
              return (
                <circle
                  cx={cx}
                  cy={cy}
                  r={isMobile ? 3 : 4}
                  fill="#f59e0b"
                  stroke="none"
                />
              );
            }}
            activeDot={(props) => {
              const { cx, cy, payload } = props;
              if (!payload || payload.hasData === false || payload.rate === null) {
                return null;
              }
              return (
                <circle
                  cx={cx}
                  cy={cy}
                  r={isMobile ? 5 : 6}
                  fill="#f59e0b"
                  stroke="#ffffff"
                  strokeWidth={2}
                />
              );
            }}
            connectNulls={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
};

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ 
        "@keyframes fadeInUp": {
          "0%": { opacity: 0, transform: "translateY(10px)" },
          "100%": { opacity: 1, transform: "translateY(0)" }
        },
        animation: "fadeInUp 0.5s ease-out forwards"
      }}>
        <Box
          sx={{
            overflow: "hidden",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            padding: { xs: "14px", sm: "20px" },
            boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
            border: "1px solid #e2e8f0",
          }}
        >
          {/* ── Header ── */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: 1,
              mb: 2,
            }}
          >
            <Box>
              <Typography sx={{ fontSize: { xs: "1rem", sm: "1.2rem" }, fontWeight: 700, color: "#1a2d4d", mb: "2px" }}>
                {titles[view].title}
              </Typography>
              <Typography sx={{ fontSize: { xs: "1rem", sm: "1.2rem" }, color: "#94a3b8" }}>
                {titles[view].sub}
              </Typography>
            </Box>

            {/* ── Controls ── */}
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap", width: "100%" }}>
              <ButtonGroup size="small" variant="outlined" sx={{ borderRadius: "5px", overflow: "hidden" }}>
                {VIEWS.map(({ key, label }) => (
                  <Button
                    key={key}
                    onClick={() => handleViewChange(key)}
                    disableRipple={false}
                    sx={{
                      fontSize: { xs: "10px", sm: "11px" },
                      px: { xs: 1.4, sm: 2 },
                      py: 0.65,
                      textTransform: "none",
                      fontWeight: view === key ? 700 : 500,
                      backgroundColor: view === key ? "#004AAD" : "transparent",
                      color: view === key ? "#ffffff" : "#004AAD",
                      borderColor: "#004AAD",
                      transition: "all 0.2s",
                      "&:hover": {
                        backgroundColor: view === key ? "#003a8c" : "rgba(0,74,173,0.07)",
                        borderColor: "#003a8c",
                      },
                    }}
                  >
                    {label}
                  </Button>
                ))}
              </ButtonGroup>

              <Box sx={{ flex: 1 }} />
              <Button
                size="small"
                variant={view === "range" ? "contained" : "outlined"}
                onClick={() => handleViewChange("range")}
                startIcon={view === "range" ? <CalendarTodayIcon /> : null}
                sx={{
                  fontSize: { xs: "10px", sm: "11px" },
                  px: { xs: 1.4, sm: 2 },
                  py: 0.65,
                  textTransform: "none",
                  fontWeight: view === "range" ? 700 : 500,
                  backgroundColor: view === "range" ? "#004AAD" : "transparent",
                  color: view === "range" ? "#ffffff" : "#004AAD",
                  borderColor: "#004AAD",
                  borderRadius: "5px",
                  transition: "all 0.2s",
                  border: "1px solid",
                  borderColor: "#004AAD",
                  "&:hover": {
                    backgroundColor: view === "range" ? "#003a8c" : "rgba(0,74,173,0.07)",
                    borderColor: "#003a8c",
                  },
                }}
              >
                Date Range
              </Button>

              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onStartChange={(date) => {
                  setStartDate(date);
                  if (date && endDate && date > endDate) {
                    setEndDate(null);
                  }
                }}
                onEndChange={(date) => {
                  setEndDate(date);
                  if (date && startDate && date < startDate) {
                    setStartDate(null);
                  }
                }}
                isMobile={isMobile}
                show={isRangeView}
              />
            </Box>
          </Box>
          {renderChart()}
          {!isEmpty && <ChartLegend showTarget={true} />}
        </Box>
      </Box>
    </LocalizationProvider>
  );
}

export default WeeklyAttendanceTrend;